// extracted by mini-css-extract-plugin
export default {"wrapper":"skills-module--wrapper--WUTc7","tech_wrapper":"skills-module--tech_wrapper--lwyVF"};